import { vndHlp, vndRgtEvts, vndSch, PageRender, vndTopbar, vndHeader, vndMbHd, slideShow, parallaxLookbook, groupContent, vndSectionSlider, vndIstSection, lookbookSection, vndPkrSt, vndMsrGrd, vndPageTabs, vndServicePromotion, vndSectionImage2 } from "//senoritasparkles.co.uk/cdn/shop/t/20/assets/theme.js?v=127951410120391145561767019661";

document.addEventListener('DOMContentLoaded', function() {
  let vndEvts = new vndRgtEvts();
  window.vndTheme.scroll_width = window.innerWidth - document.body.clientWidth;

  vndHlp.initSct(null, '#shopify-section-top-bar', vndTopbar.onLoad);
  vndHlp.initSct(null, '#shopify-section-header', vndHeader.onLoad);
  vndHlp.initSct(null, '#shopify-section-header-mobile', vndMbHd.onLoad);
  vndHlp.initSct(null, 'section.vs-homepage-slideshow', slideShow.onLoad);
  vndHlp.initSct(null, 'section.vs-parallax-lookbook', parallaxLookbook.onLoad);
  vndHlp.initSct(null, 'section.vs-group-content', groupContent.onLoad);
  vndHlp.initSct(null, 'section.vs-initialize-slider', vndSectionSlider.onLoad);
  vndHlp.initSct(null, 'section.vs-collections-tab', vndIstSection.onLoad);
  vndHlp.initSct(null, 'section.vs-lookbook', lookbookSection.onLoad);
  vndHlp.initSct(null, 'section.vs-packery', vndPkrSt.onLoad);
  vndHlp.initSct(null, 'section.vs-masonry-grid', vndMsrGrd.onLoad);
  vndHlp.initSct(null, 'section.vs-page-tabs', vndPageTabs.onLoad);
  vndHlp.initSct(null, '.vs-service-promotion', vndServicePromotion.onLoad);
  vndHlp.initSct(null, '.vs-image-2', vndSectionImage2.onLoad);

  PageRender.init();

  vndSch();
});
